export interface IProcurementRequirementAnswer{
    value?: string;
    identifier?: string;
}

export interface IPurchaseRequirement{
    label: string;
    id: string;
    inputType: string;
    inputValues: string[];
    selectedValues: string[];
    required: boolean;
    description?: string;
    category?: string;
}

export interface IFulfillment {
    id?: string;
    carrier?: string;
    orderId?: string;
    trackingNumber?: string;
    trackingLink?: string;
    itemReferences?: IFulfillmentItemReference[]
    eta?: Date;
    status?: string;
    completeDate?: Date;
    active?: boolean;
}

export interface IProcurementEvent{
    orderId?: string;
    externalOrderId?: string;
    id?: string;
    eventType?: string;
    eventDetails?: string;
    eventDate?: string;
    username?: string;
    vendor?: string;
}

export interface IFulfillmentItemReference{
    procurementItemId?: string;
    quantity?: number;
    manufacturerPartNumber?: string;
    lineNumber?: string;
    vendorPartNumber?: string
}

export interface IShipment {
    id?: string;
    carrier?: string;
    trackingNumber?: string;
    trackingLink?: string;
    itemIds?: string[];
    eta?: Date;
    status?: string;
    completeDate?: Date;
    active?: boolean;
    events?: IShipmentEvent[]
}

export interface IShipmentEvent {
    eventType?: string;
    eventDate?: Date;
}

export const ORDER_STATUSES = {
    SUBMITTED: 'Submitted',
    CONFIRMED: 'Confirmed',
    PENDING: 'Pending',
    CREDIT_HOLD: 'Credit Hold',
    IN_PROGRESS: 'In Progress',
    BACKORDERED: 'Backordered',
    PARTIAL: 'Partial',
    FULFILLED: 'Fulfilled',
    COMPLETE: 'Complete',
    CANCELLED: 'Cancelled',
    SHIPPED: 'Shipped',
}
